import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import '@/assets/css/global-m.css' //引入移动端全局样式配置
import '@/assets/css/richText.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './filters'

import App from './App'
import store from './store'
import router from './router'
import VueI18n from 'vue-i18n'
import i18n from '@/locale/index'
import '@/components'
import '@/assets/css/qe.css'

import '@/assets/css/style.scss'
//自定义js事件
import base from '@/utils/base'
import { getLang, setLang } from '@/utils/index'
Vue.prototype.$base = base

//创建bus  供平行组件通信
let bus = new Vue()
Vue.prototype.bus = bus

/**
 *vant注册
 */

Vue.use(Vant)
Vue.use(ElementUI)
import { Pagination } from 'element-ui'
Vue.use(Pagination)
//Lazyload
import { Lazyload } from 'vant'
Vue.use(Lazyload)
Vue.use(VueI18n)

Vue.config.productionTip = false

//全局过滤器
Vue.filter('dataFilter', function(value, showMinutes = false) {
  //创建补0函数
  function timeAdd0(str) {
    if (str.length <= 1) {
      str = '0' + str
    }
    return str
  }
  let date = new Date(Number(value)),
    year = timeAdd0(date.getFullYear().toString()),
    month = timeAdd0((date.getMonth() + 1).toString()),
    day = timeAdd0(date.getDate().toString()),
    hours = timeAdd0(date.getHours().toString()),
    minutes = timeAdd0(date.getMinutes().toString())
  if (showMinutes) return `${year}-${month}-${day}  ${hours}:${minutes}`
  else return `${year}-${month}-${day}`
})
router.beforeEach(async (to, from, next) => {
  const lang = getLang() || 'zh-CN'
  const lang1 = to.query.site_lang
  if (lang1 !== undefined) {
    setLang(lang1)
  } else {
    setLang(lang)
  }
  next()
})
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})
